import Typography from "antd/lib/typography";
import clsx from "clsx";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { getUserDisplayName, IUserResource } from "@sol/sdk";

import { UserAvatar } from "./UserAvatar";

type Props = {
    user: IUserResource;
    type: "createdAt" | "updatedAt";
    date: string;
    className?: string;
};

export const UserWithDate = ({ user, type, date, className }: Props) => {
    const [t] = useTranslation();

    return (
        <div className={clsx(className, "flex items-center gap-2")}>
            <UserAvatar user={user} />
            <div>
                <Typography.Text className="line-clamp-2" title={getUserDisplayName(user)}>
                    {getUserDisplayName(user)}
                </Typography.Text>
                <Typography.Text className="max-w-[110px] truncate text-ant-sm text-color-ant-secondary">
                    {t(`component.BriefCard.${type}`, { date: format(new Date(date), "dd/MM/yy") })}
                </Typography.Text>
            </div>
        </div>
    );
};
